import React from 'react';
import {useLocation} from "react-router-dom";

const Fallback =  () => {
    let location = useLocation();

    if (location.hash) {
        let newUrl = location.hash.substr(1, location.hash.length);
        window.location.href = newUrl;
    } else {
        return <React.Fragment/>;
    }
}

export default Fallback;